import React from 'react';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

export interface ReportData {
  id: number;
  pharmacyNum: string;
  balanceOfStart: number;
  balanceOfEnd?: number;
  cash?: number;
  cashless?: number;
  audit?: number;
  checkStatus?: number;
  overage?: number;
  shortfall?: number;
  [key: string]: any;
}

const formatNumber = (value: any): string => {
  if (!value || parseFloat(value) === 0) return '';
  const num = parseFloat(value);
  const parts = num.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join(',');
};

const getMonthName = (selectedMonth: string): string => {
  const months = [
    'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
    'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
  ];
  const monthIndex = parseInt(selectedMonth.split('-')[1]) - 1;
  return months[monthIndex];
};

const getYear = (selectedMonth: string): string => {
  return selectedMonth.split('-')[0];
};

export const generateMathReport = async (
  reportData: ReportData,
  selectedMonth: string,
  pharmacyNum: string,
  employeeName: string
) => {
  try {
    const response = await fetch('/templates/material_report.docx');
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();

    const calculateSum = (values: number[]): string => {
      const sum = values.reduce((acc, val) => acc + (val || 0), 0);
      return sum === 0 ? '' : formatNumber(sum);
    };

    const data = {
      pharmacyNum,
      currentMonth: getMonthName(selectedMonth),
      currentYear: getYear(selectedMonth),
      employeeName,
      
      balanceOfStart: formatNumber(reportData?.balanceOfStart),
      arrivalFromStock: formatNumber(reportData?.arrivalFromStock),
      beforeMarkup: formatNumber(reportData?.beforeMarkup),
      receiptOfGoods: formatNumber(reportData?.receiptOfGoods),
      overage: formatNumber(reportData?.overage),
      totalCashless: formatNumber(reportData?.totalCashless),
      totalCash: formatNumber(reportData?.totalCash),
      markdown: formatNumber(reportData?.markdown),
      returnToStock: formatNumber(reportData?.returnToStock),
      charity: formatNumber(reportData?.charity),
      writeOff: formatNumber(reportData?.writeOff),
      householdNeeds: formatNumber(reportData?.householdNeeds),
      shortfall: formatNumber(reportData?.shortfall ),

      sumIncome: formatNumber(reportData?.sumIncome ),
      sumOutcome: formatNumber(reportData?.sumOutcome ),
      difference: formatNumber(reportData?.difference ),

      formValue: formatNumber(reportData?.vat )
    };

    const sumIncome = parseFloat(data.sumIncome.replace(/\s/g, '').replace(',', '.')) || 0;
    const sumOutcome = parseFloat(data.sumOutcome.replace(/\s/g, '').replace(',', '.')) || 0;
    const difference = sumIncome - sumOutcome;

    const finalData = {
      ...data,
      difference: difference === 0 ? '' : formatNumber(difference)
    };

    const zip = new PizZip(arrayBuffer);
    const doc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true
    });

    doc.render(finalData);

    const out = doc.getZip().generate({
      type: 'blob',
      mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    });

    const fileName = `Материальный отчет за ${selectedMonth} аптека №${pharmacyNum}.docx`;
    saveAs(out, fileName);

  } catch (error) {
    console.error('Ошибка при генерации отчета:', error);
    throw new Error('Ошибка при создании отчета');
  }
};